import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import '../App.css';

class SingleQ extends Component {
  state = {
    question: '',
    option: [],
    index: '',
    selectedOption: '',
  };

  handleRadio = (event) => {
    console.log(event.target.value);
    this.setState({ selectedOption: event.target.value });
    this.props.StateStore.changeSelected(event.target.value);
  };

  render() {
    return (
      <div className='eachQuestion'>
        <h2>{this.props.questionDetail.question}</h2>
        {
          /* <Options questionDetails={this.props.questionDetail} /> */
          this.props.questionDetail.options.map((option, i) => {
            return (
              <div className='options' key={i}>
                <label>
                  <input
                    type='radio'
                    name='work'
                    value={option}
                    checked={this.state.selectedOption === `${option}`}
                    onChange={this.handleRadio}
                  />
                  {option}
                </label>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default inject('StateStore')(observer(SingleQ));
